import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { User } from 'firebase/auth'
import type { RootState } from './store'

// Define a type for the slice state
interface UserState {
  id: string
  username: string
  firebaseUser: User | null
}

// Define the initial state using that type
const initialState: UserState = {
  id: '',
  username: '',
  firebaseUser: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        id: string
        username: string
        firebaseUser: User | null
      }>
    ) => {
      state.id = action.payload.id
      state.username = action.payload.username
      state.firebaseUser = action.payload.firebaseUser
    },
  },
})

// export actions
export const { setUser } = userSlice.actions

// export selectors
export const selectUserId = (state: RootState) => state.user.id
export const selectUsername = (state: RootState) => state.user.username

// export the reducer
export const userReducer = userSlice.reducer
